import {
  POC_DATA_REQUEST,
  POC_DATA_SUCCESS,
  POC_DATA_FAIL,
} from '../constants/pusposeOfCoverageConstants';

export const purposeOfCoverageReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case POC_DATA_REQUEST:
      return { loading: true, formData: [] };
    case POC_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case POC_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
